/**
 * Legal Document Service
 *
 * Handles API calls to fetch legal documents (Terms and Conditions, Privacy Policy) from the backend.
 * The backend fetches these documents from SQL database by LegalTypeID.
 *
 * Legal Type IDs:
 * - 1: Terms and Conditions
 * - 2: Privacy Policy
 */

import { API_URLS } from '../constants/apiUrls';

export interface LegalDocument {
  fileContent: string;    // HTML content of the legal document
  actualFileName: string; // Original filename
}

/**
 * Fetches a legal document from the backend by its type ID
 *
 * @param typeId - Legal document type ID (1 for Terms, 2 for Privacy)
 * @returns Promise containing the HTML content and filename
 * @throws Error if the API call fails
 */
export async function getLegalDocument(typeId: number): Promise<LegalDocument> {
  try {
    const response = await fetch(API_URLS.legalDocument(typeId), {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
    });

    if (!response.ok) {
      throw new Error(`Failed to fetch legal document: ${response.statusText}`);
    }

    // Parse the response - backend should return { fileContent, actualFileName }
    const data: LegalDocument = await response.json();

    if (!data.fileContent) {
      throw new Error('No content received from server');
    }

    return data;
  } catch (error) {
    /* console.error(`Error fetching legal document (typeId: ${typeId}):`, error); */
    throw error;
  }
}
